export enum AuthSchemeEnum {
    OAUTH = 'oauth',
    SAML = 'saml',
    BASIC_AUTHENTICATION = 'basicAuth',
}
